import React from "react";
import { cn } from "../../utils";

export type ColumnSeparatorProps = {
  show?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

const ColumnSeparator = ({ show, className, ...props }: ColumnSeparatorProps) => {
  if (!show) return null;
  return (
    <span
      data-slot="table-head-separator"
      className={cn("absolute right-0 top-1/2 h-4 w-px -translate-y-1/2 bg-gray-300", className)}
      {...props}
    />
  );
};

export default React.memo(ColumnSeparator);
